import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { RmaMasterDetailModel } from 'src/app/shared/models/rma.model';
import { UserModel } from 'src/app/shared/models/user.model';
import { RmaMasterService } from 'src/app/shared/services/rma-master.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-rma-recent',
  templateUrl: './rma-recent.component.html',
  styleUrls: ['./rma-recent.component.css']
})
export class RmaRecentComponent implements OnInit {

  users : UserModel [];
  thisData : MatTableDataSource<any>;
  displayColumn : string[]= ['date', 'client', 'rma_type_requested','destination'];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;

  constructor(
    private service :RmaMasterService,
    private userservice : UserService ) {

    }

  ngOnInit() {


    this.userservice.getUserList().subscribe(
      res=>{
        this.users = res as UserModel [];
        this.refreshList();
      },
      err=>{}
    );


  }


  refreshList()
  {
      this.service.getListbyStatus("standby").subscribe(
        res => {
          let array = res as RmaMasterDetailModel[];
            let result = array.map(
              obj => {
                obj.createByUser = this.users.find(item => item.id === obj.createBy);
                obj.statusByUser = this.users.find(item => item.id === obj.statusBy);
                return {...obj}
              }
            );

          this.thisData = new MatTableDataSource(array);
         },
         err =>{
           console.log(err);
         }
      );

  }

  getRmaTypeString(type)
  {
    return GlobalConstants.getRmaTypeString(type);
  }

  getCountryString(code)
  {
    return GlobalConstants.getCountryString(code);
  }

}
